module.exports = __webpack_public_path__ + "static/media/13@2x.6324188d.png";